$font-family-graphik: 'Graphik', sans-serif;

sn-transformation-type-1 {
  .transformation-type-1 {
    width: 100%;

    .me-container {
      margin: 0 auto;
      padding: var(--spacing-2xl) var(--spacing-md) var(--spacing-2xl) var(--spacing-md);
      max-width: 1312px;
    }

    .transformation-type-1__heading-column {
      @include above($media-desktop) {
        margin-left: auto;
        margin-right: auto;
      }

      me-heading {
        display: block;
        text-align: center;
      }

      me-text {
        display: block;
        margin-left: auto;
        margin-right: auto;
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 28px;
        text-align: center;

        @include above(768px) {
          font-size: 16px;
          line-height: 24px;
          margin-bottom: 40px;
          max-width: 576px;
        }

        @include above(960px) {
          max-width: 661px;
          margin-bottom: 48px;
        }

        @include above($media-desktop) {
          font-size: 20px;
          line-height: 28px;
          margin-bottom: 60px;
          max-width: 661px;
        }
      }
    }

    // ========================================
    // Cards Container (tranformation-cards)
    // Uses absolute positioning like reference
    // ========================================
    .transformation-type-1__cards {
      position: relative;
      margin-left: auto;
      margin-right: auto;
      width: 328px;
      min-height: 860px;

      @include above(344px) {
        width: 344px;
      }

      @include above(768px) {
        width: 608px;
        min-height: 880px;
      }

      @include above(960px) {
        width: 928px;
        min-height: 536px;
      }

      @include above($media-desktop) {
        width: 100%;
        min-height: 684px;
      }
    }

    // ========================================
    // Base Card Styles (tranformation-card)
    // ========================================
    .transformation-type-1__card {
      position: absolute;
    }

    .transformation-type-1__card-wrapper {
      border-radius: 12px;
      overflow: hidden;
      position: relative;
      z-index: 1;
      padding: 16px 20px 20px;

      @include above(768px) {
        height: 160px;
        padding: 16px 24px 24px;
      }

      @include above($media-desktop) {
        height: 206px;
        padding: 24px 32px 42px;
      }
    }

    .transformation-type-1__card-title {
      .me-heading {
        font-weight: 700;
        color: #fff;
        font-size: 48px;
        line-height: 60px;
        margin-bottom: 0;

        @include above(768px) {
          font-size: 60px;
          line-height: 72px;
        }

        @include above($media-desktop) {
          font-size: 72px;
          line-height: 84px;
        }
      }

      &--black {
        .me-heading {
          color: #100419;
        }
      }
    }

    .transformation-type-1__card-description {
      font-family: $font-family-graphik;
      font-size: 14px;
      line-height: 20px;
      color: #fff;
      max-width: 124px;

      @include above(768px) {
        font-size: 16px;
        line-height: 24px;
        max-width: 168px;
      }

      @include above($media-desktop) {
        font-size: 20px;
        line-height: 28px;
        max-width: 201px;
      }

      &--black {
        color: #100419;
      }
    }

    // ========================================
    // Card 1: Completion Rate (80%)
    // ========================================
    .transformation-type-1__card--completion-rate {
      top: 0;
      left: 0;

      @include above($media-desktop) {
        left: calc(var(--spacing-6xl) / 2);
      }

      .transformation-type-1__card-wrapper {
        background-color: #100419;
        height: 148px;
        width: 328px;

        @include above(344px) {
          width: 343px;
        }

        @include above(768px) {
          width: 376px;
          height: 160px;
        }

        @include above($media-desktop) {
          width: 503px;
          height: 206px;
        }
      }
    }

    .completion-rate-illustration {
      position: absolute;
      right: 24px;
      top: 24px;
      width: 148px;

      @include above(768px) {
        top: 26px;
        width: 168px;
        right: 20px;
      }

      @include above($media-desktop) {
        top: 36px;
        width: 220px;
        right: 39px;
      }
    }

    .progress {
      position: relative;
      overflow: hidden;
      width: 148px;
      height: 18px;
      background: #2c2c2c;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;

      @include above(768px) {
        width: 168px;
        height: 21px;
      }

      @include above($media-desktop) {
        width: 220px;
        height: 27px;
        border-radius: 8px;
      }

      // Animation — hidden until IntersectionObserver fires
      opacity: 0;
      transform: translateY(20px);
      transition:
        opacity 0.6s ease,
        transform 0.6s ease;

      &.is-visible {
        opacity: 1;
        transform: translateY(0);
      }

      // No JS: show immediately
      @media (scripting: none) {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .progress__title {
      font-size: 10px;
      line-height: 16px;
      color: #fff;

      @include above(768px) {
        font-size: 10px;
        line-height: 18px;
      }

      @include above($media-desktop) {
        font-size: 14px;
        line-height: 24px;
      }
    }

    .progress__bar {
      background: #36a269;
      width: 0;
      height: 100%;
      top: 0;
      left: 0;
      border-radius: 0 6px 6px 0;
      position: absolute;
      z-index: -1;
      transition: all 0.7s ease;

      @include above($media-desktop) {
        border-radius: 0 8px 8px 0;
      }
    }

    .progress.is-visible .progress__bar {
      width: 90%;
    }

    .document {
      position: relative;
      margin-top: 11px;

      @include above(768px) {
        margin-top: 5px;
      }

      @include above($media-desktop) {
        margin-top: 1px;
      }

      me-picture,
      img {
        position: relative;
        left: -5px;
        top: 0;
        width: 177px;

        @include above(768px) {
          width: 201px;
        }

        @include above($media-desktop) {
          width: 263px;
          left: -10px;
        }
      }

      // Animation
      opacity: 0;
      transform: translateY(20px);
      transition:
        opacity 0.6s ease,
        transform 0.6s ease;

      &.is-visible {
        opacity: 1;
        transform: translateY(0);
      }
    }

    // ========================================
    // Card 2: Average Sent (1h)
    // ========================================
    .transformation-type-1__card--average-sent {
      top: 164px;
      left: 0;

      @include above(768px) {
        left: 392px;
        top: 0;
      }

      @include above(960px) {
        left: 400px;
      }

      @include above($media-desktop) {
        left: calc(535px + var(--spacing-6xl) / 2);
      }

      .transformation-type-1__card-wrapper {
        background-color: #7561e9;
        height: 176px;
        width: 158px;

        @include above(344px) {
          width: 164px;
        }

        @include above(768px) {
          width: 216px;
          height: 160px;
        }

        @include above($media-desktop) {
          width: 320px;
          height: 206px;
        }
      }
    }

    // ========================================
    // Card 3: Integrations Box (20+)
    // ========================================
    .transformation-type-1__card--integrations-box {
      top: 520px;
      left: 0;

      @include above(768px) {
        top: 360px;
        right: 0;
        left: auto;
      }

      @include above(960px) {
        top: 0;
      }

      @include above($media-desktop) {
        right: calc(var(--spacing-6xl) / 2);
      }

      .transformation-type-1__card-description {
        @include above(768px) {
          position: absolute;
          top: 28px;
          right: 49px;
        }

        @include above(960px) {
          position: relative;
          top: 0;
          right: 0;
        }
      }

      .transformation-type-1__card-wrapper {
        background-color: #271b6f;
        width: 158px;
        height: 176px;

        @include above(344px) {
          width: 164px;
        }

        @include above(768px) {
          width: 375px;
          height: 344px;
        }

        @include above(960px) {
          width: 288px;
          height: 352px;
        }

        @include above($media-desktop) {
          width: 396px;
          height: 446px;
        }
      }

      // Apps Grid (for integrations card)
      .apps {
        display: none;

        @include above(768px) {
          margin-left: -8px;
          margin-right: -8px;
          margin-top: 15px;
          display: flex;
          flex-wrap: wrap;
        }

        @include above(960px) {
          margin-left: -6px;
          margin-right: -6px;
        }

        @include above($media-desktop) {
          margin-top: 31px;
          margin-left: -8px;
          margin-right: -8px;
        }
      }

      .apps__item {
        width: 33.3333%;

        @include above(768px) {
          margin-bottom: 16px;
          padding: 0 8px;
        }

        @include above(960px) {
          padding: 0 6px;
          margin-bottom: 12px;
        }

        @include above($media-desktop) {
          margin-bottom: 16px;
          padding: 0 8px;
        }

        // Animation
        opacity: 0;
        transition:
          opacity 0.6s ease,
          transform 0.6s ease;

        &[data-animate='fade-in-left'] {
          transform: translateX(-20px);
        }

        &[data-animate='fade-in-right'] {
          transform: translateX(20px);
        }

        &[data-animate='fade-in-up'] {
          transform: translateY(20px);
        }

        &[data-animate='fade-in-down'] {
          transform: translateY(-20px);
        }

        &.is-visible {
          opacity: 1;
          transform: translate(0);
        }

        &--double-size {
          width: 66.666%;
        }
      }

      .apps__wrapper {
        position: relative;
        background: #fff;
        box-shadow: 0 6px 20px rgb(0 0 0 / 10%);
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 84px;
        transition: all 0.3s ease;
        min-height: inherit;

        @include above(768px) {
          height: 99px;
        }

        @include above(960px) {
          height: 72px;
          border-radius: 8px;
        }

        @include above($media-desktop) {
          height: 99px;
          border-radius: 12px;
        }

        &:hover {
          box-shadow: 0 2px 12px rgb(0 0 0 / 10%);
        }
      }

      .apps__link {
        position: absolute;
        z-index: 1;
        inset: 0;
        border-radius: 12px;
      }

      .apps__logo {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .apps__icon {
        display: block;
        height: auto;

        &--gdrive,
        &--gdrive img {
          width: 40px;
          height: 35px;

          @include above(768px) {
            width: 45px;
            height: 40px;
          }

          @include above(960px) {
            width: 33px;
            height: 30px;
          }

          @include above($media-desktop) {
            width: 46px;
            height: 41px;
          }
        }

        &--ms-teams,
        &--ms-teams img {
          width: 44px;
          height: 44px;

          @include above(768px) {
            width: 51px;
            height: 51px;
          }

          @include above(960px) {
            width: 38px;
            height: 37px;
          }

          @include above($media-desktop) {
            width: 51px;
            height: 51px;
          }
        }

        &--ms-word,
        &--ms-word img {
          width: 37px;
          height: 35px;

          @include above(768px) {
            width: 43px;
            height: 40px;
          }

          @include above(960px) {
            width: 31px;
            height: 29px;
          }

          @include above($media-desktop) {
            width: 43px;
            height: 40px;
          }
        }

        &--salesforce {
          width: 53px;
          height: 37px;

          @include above(768px) {
            width: 61px;
            height: 44px;
          }

          @include above(960px) {
            width: 45px;
            height: 32px;
          }

          @include above($media-desktop) {
            width: 61px;
            height: 44px;
          }
        }

        &--netsuite,
        &--netsuite img {
          width: 118px;
          height: 30px;

          @include above(768px) {
            width: 135px;
            height: 34px;
          }

          @include above(960px) {
            width: 98px;
            height: 26px;
          }

          @include above($media-desktop) {
            width: 135px;
            height: 34px;
          }
        }
      }
    }

    // ========================================
    // Card 4: Average Invites (96k)
    // ========================================
    .transformation-type-1__card--average-invites {
      top: 164px;
      right: 0;

      @include above(768px) {
        left: 0;
        top: 176px;
        right: auto;
      }

      @include above(960px) {
        top: 184px;
      }

      @include above($media-desktop) {
        top: 240px;
        left: calc(var(--spacing-6xl) / 2);
      }

      .transformation-type-1__card-wrapper {
        background-color: #271b6f;
        width: 158px;
        height: 176px;

        @include above(344px) {
          width: 164px;
        }

        @include above(768px) {
          width: 217px;
          height: 352px;
        }

        @include above($media-desktop) {
          width: 288px;
          height: 444px;
        }
      }
    }

    .average-invites-illustration {
      position: relative;
      display: none;

      @include above(768px) {
        margin-top: 31px;
        display: block;
      }

      @include above($media-desktop) {
        margin-top: 39px;
      }

      img,
      me-picture {
        position: absolute;

        @include above(768px) {
          width: 188px;
          left: -1px;
        }

        @include above($media-desktop) {
          width: 261px;
          left: -11px;
        }
      }

      // Animation
      opacity: 0;
      transform: translateY(20px);
      transition:
        opacity 0.6s ease,
        transform 0.6s ease;

      &.is-visible {
        opacity: 1;
        transform: translateY(0);
      }
    }

    // ========================================
    // Card 5: HIPPA/Education (28.9k)
    // ========================================
    .transformation-type-1__card--hippa {
      top: 356px;
      left: 0;

      @include above(768px) {
        top: 176px;
        right: 0;
        left: auto;
      }

      @include above(960px) {
        top: 184px;
        left: 240px;
        right: auto;
      }

      @include above($media-desktop) {
        top: 240px;
        left: calc(322px + var(--spacing-6xl) / 2);
      }

      .transformation-type-1__card-wrapper {
        background-color: #e9ffc5;
        width: 328px;
        height: 148px;

        @include above(344px) {
          width: 343px;
        }

        @include above(768px) {
          width: 375px;
          height: 168px;
        }

        @include above($media-desktop) {
          width: 532px;
          height: 206px;
        }
      }
    }

    .hippa-illustration {
      position: absolute;
      width: 105px;
      top: 22px;
      right: 24px;

      @include above(768px) {
        width: 126px;
        top: 19px;
        right: 39px;
      }

      @include above($media-desktop) {
        right: 33px;
        top: 31px;
        width: 168px;
      }
    }

    .hippa-illustration__item {
      position: absolute;
      top: 0;

      img,
      me-picture {
        width: 46px;
        height: 46px;

        @include above(768px) {
          width: 58px;
          height: 58px;
        }

        @include above($media-desktop) {
          width: 73px;
          height: 72px;
        }
      }

      &--01 {
        left: 0;
        z-index: 3;
      }

      &--02 {
        z-index: 2;
        left: 29px;

        @include above(768px) {
          left: 38px;
        }

        @include above($media-desktop) {
          left: 52px;
        }
      }

      &--03 {
        z-index: 1;
        left: 63px;

        @include above(768px) {
          left: 79px;
        }

        @include above($media-desktop) {
          left: 104px;
        }
      }

      // Animation
      opacity: 0;
      transform: translateX(20px);
      transition:
        opacity 0.6s ease,
        transform 0.6s ease;

      &.is-visible {
        opacity: 1;
        transform: translateX(0);
      }
    }

    // ========================================
    // Card 6: Average Clicks (2)
    // ========================================
    .transformation-type-1__card--average-clicks {
      right: 0;
      top: 520px;

      @include above(768px) {
        left: 0;
        right: auto;
        top: 544px;
      }

      @include above(960px) {
        left: 240px;
        top: 376px;
      }

      @include above($media-desktop) {
        left: calc(322px + var(--spacing-6xl) / 2);
        top: 478px;
      }

      .transformation-type-1__card-wrapper {
        background-color: #5641d4;
        width: 158px;
        height: 176px;

        @include above(344px) {
          width: 164px;
        }

        @include above(768px) {
          width: 216px;
          height: 160px;
        }

        @include above($media-desktop) {
          width: 319px;
          height: 206px;
        }
      }
    }

    .clicks-illustration {
      position: absolute;
      display: none;

      @include above(768px) {
        top: 16px;
        right: 27px;
        display: block;
      }

      @include above($media-desktop) {
        top: 24px;
        right: 29px;
      }

      img,
      me-picture {
        @include above(768px) {
          width: 72px;
          height: 72px;
        }

        @include above($media-desktop) {
          width: 81px;
          height: 80px;
        }
      }

      // Animation
      opacity: 0;
      transform: translateY(20px);
      transition:
        opacity 0.6s ease,
        transform 0.6s ease;

      &.is-visible {
        opacity: 1;
        transform: translateY(0);
      }
    }

    // ========================================
    // Card 7: API Calls (14.3M)
    // ========================================
    .transformation-type-1__card--api-cals {
      top: 712px;
      left: 0;

      @include above(768px) {
        top: 720px;
      }

      @include above(960px) {
        top: 376px;
        right: 0;
        left: auto;
      }

      @include above($media-desktop) {
        top: 478px;
        right: calc(var(--spacing-6xl) / 2);
      }

      .transformation-type-1__card-title {
        font-size: 44px;

        @include above(344px) {
          font-size: 48px;
          line-height: 60px;
        }

        @include above(768px) {
          font-size: 60px;
          line-height: 72px;
        }

        @include above($media-desktop) {
          font-size: 72px;
          line-height: 84px;
        }
      }

      .transformation-type-1__card-wrapper {
        background-color: #100419;
        width: 328px;
        overflow: hidden;
        height: 148px;

        @include above(344px) {
          width: 343px;
        }

        @include above(768px) {
          width: 605px;
          height: 160px;
        }

        @include above(960px) {
          width: 447px;
        }

        @include above($media-desktop) {
          width: 609px;
          height: 206px;
        }
      }
    }

    .api-cals-illustration {
      position: absolute;
      width: 148px;
      top: 58px;
      right: 16px;

      @include above(768px) {
        width: 235px;
        top: 23px;
        right: 50px;
      }

      @include above(960px) {
        top: 26px;
        right: 21px;
        width: 179px;
      }

      @include above($media-desktop) {
        top: 35px;
        right: 43px;
        width: 255px;
      }
    }

    .api-cals-illustration__item {
      position: absolute;

      &--avatar {
        z-index: 1;
        left: -40px;
        top: 30px;
        transform: translateX(-20px);

        @include above(960px) {
          left: -50px;
          top: 54px;
        }

        @include above($media-desktop) {
          left: -70px;
          top: 78px;
        }

        img,
        me-picture {
          width: 46px;
          height: 45px;

          @include above(768px) {
            width: 73px;
            height: 72px;
          }

          @include above(960px) {
            width: 56px;
            height: 55px;
          }

          @include above($media-desktop) {
            width: 80px;
            height: 77px;
          }
        }
      }

      &--code {
        top: -10px;
        left: -14px;
        transform: translateY(20px);

        @include above(768px) {
          top: -14px;
          left: -17px;
        }

        @include above(960px) {
          top: 3px;
        }

        @include above($media-desktop) {
          top: -15px;
          left: -21px;
        }

        img,
        me-picture {
          width: 177px;

          @include above(768px) {
            width: 274px;
          }

          @include above(960px) {
            width: 210px;
          }

          @include above($media-desktop) {
            width: 299px;
          }
        }
      }

      // Animation
      opacity: 0;
      transition:
        opacity 0.6s ease,
        transform 0.6s ease;

      &.is-visible {
        opacity: 1;
        transform: translate(0);
      }
    }
  }
}
